var render = function render(){var _vm=this,_c=_vm._self._c;return _c('upload-default',{staticClass:"upload-comprovante",attrs:{"label":"Faça upload do comprovante aqui"}})
}
var staticRenderFns = []

export { render, staticRenderFns }